module.exports = __webpack_public_path__ + "static/media/fs1.39369357.pdf";